import { z } from 'zod';

import { OrderDirection } from '@/constants/orderDirection';

/** DataGrid 系ルートの URL 既定ページサイズ（`dataGridSearchFields.pageSize` と一致） */
export const DATA_GRID_DEFAULT_PAGE_SIZE = 100;

/**
 * DataGridResponse 系ルート共通の search params。
 * route 側は z.object({ ...dataGridSearchFields, ...routeSpecific }) で合成し、
 * sortColumn を z.enum() で narrow する。
 */
export const dataGridSearchFields = {
  pageIndex: z.number().default(0),
  pageSize: z.number().default(DATA_GRID_DEFAULT_PAGE_SIZE),
  sortColumn: z.string().optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
};
